export default {
  lang: {
    confirm: {
      title: 'Silmek istediğini onaylıyor musun? Sildikten sonra geri yüklenemez',
      okText: 'Silme',
      cancelText: 'İptal',
    },
  },
};
